import React, { useMemo, useState } from "react";
import "./Physicalitem.css";
import { Icon } from "@iconify/react";
import Dropdown from "react-bootstrap/Dropdown";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Multiselect from "multiselect-react-dropdown";
import countryList from "react-select-country-list";

function Physicalitem() {
  const options = useMemo(() => countryList().getData(), []);

  const [age, setAge] = React.useState("");
  const [value, setValue] = useState("");
  const changeHandler = (value) => {
    setValue(value);
  };
  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const worldwidecheck = (e) => {
    document.getElementById("select-c").classList.toggle("wwactive");
  };

  return (
    <div>
      <section className="physical-item  create-own-bg">
        <div className="hero-section">
          <div className="container">
            <div className="row">
              <div className="col-12 right">
                <h1>
                  Create <span style={{ color: "#fff" }}>Physical</span> listing{" "}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="physical-item-content">
          <div className="container">
            <div className="row ">
              <div className="col-1"></div>

              <div className="col-10">
                <h6>Image, Video Upload</h6>
                <p className="filetype">
                  File types supported : JPG, PNG, GIF, SVG, MP4, WEBM, WAV,
                  OGG, GLB, GLTF . Max size : 100MB
                </p>

                <div className="row mt-5">
                  <div className="col-md-4">
                    <img
                      src="../../assets/images/createyourown/chooseimg.png"
                      alt=""
                      className="img-fluid img-picker"
                    />
                  </div>

                  <div className="col-md-8">
                    {/* ------------ */}
                    <div className=" rigt-side-wrap d-flex justify-content-between flex-column h-100">
                      <div>
                        <h3 className="craete-tit">Item Name :</h3>
                        <input
                          className="create-input-txt mt-2 quan"
                          placeholder="Mojo T - Shirts"
                          type="text"
                        />
                      </div>
                      <div>
                        <h3 className="craete-tit">Quantity :</h3>
                        <input
                          className="create-input-txt mt-2 quan"
                          placeholder="5"
                          type="number"
                        />
                      </div>
                      <div>
                        <div className="for-country-wrap">
                          <div className="worldwide">
                            <h3 className="craete-tit mb-2">Worldwide</h3>
                            <input
                              type="checkbox"
                              onChange={(e) => worldwidecheck(e)}
                            />
                          </div>

                          <div id="select-c" className="select-country">
                            <h3 className="craete-tit mb-2">
                              Select Country :
                            </h3>
                            <Multiselect
                              displayValue="key"
                              onKeyPressFn={function noRefCheck() {}}
                              onRemove={function noRefCheck() {}}
                              onSearch={function noRefCheck() {}}
                              onSelect={function noRefCheck() {}}
                              options={options.map((item) => {
                                return { key: item.label, cat: item.value };
                              })}
                              showCheckbox
                            />
                          </div>
                        </div>
                      </div>

                      <div className="mt-2 d-flex justify-content-between flex-wrap stime">
                        <select id="time" className="s-time">
                          <option value="Select Time">Select Time</option>
                          <option value="saab">12:00</option>
                          <option value="saab">12:00</option>
                          <option value="saab">12:00</option>
                          <option value="saab">12:00</option>
                        </select>

                        <input type="date" className="s-date" />
                      </div>
                    </div>
                    {/* ------------ */}
                  </div>

                  <div className="col-12 mt-4">
                    <div className="text-area-section">
                      <h3 className="craete-tit mt-3">Description</h3>
                      <p className="create-txt mt-3">
                        The description will be included on the item's detail
                        page underneath its image.{" "}
                        <span className="xx">Markdown </span>
                        syntax is supported.
                      </p>
                      <textarea
                        rows="4"
                        className="textareadescription mt-3"
                        placeholder="Provide a detailed description of your item."
                      />
                    </div>
                  </div>

                  <div className="row product-sizes mt-5">
                    <div className="col-md-4">
                      <h3 className="craete-tit">Product Sizes</h3>
                      <p className="mt-3">
                        This is the sizes of physical items.
                        <Icon
                          icon="charm:circle-warning"
                          color="#817f7f"
                          width="16"
                          height="16"
                        />
                      </p>

                      <label>
                        <input
                          className="size"
                          type="radio"
                          name="size"
                          value="small"
                          onChange={(e) => {
                            console.log(e.target.value);
                          }}
                        />
                        <h3 className="sizelabel">S</h3>
                      </label>

                      <label>
                        <input
                          className="size"
                          type="radio"
                          name="size"
                          value="small"
                          onChange={(e) => {
                            console.log(e.target.value);
                          }}
                        />
                        <h3 className="sizelabel">M</h3>
                      </label>

                      <label>
                        <input
                          className="size"
                          type="radio"
                          name="size"
                          value="small"
                          onChange={(e) => {
                            console.log(e.target.value);
                          }}
                        />
                        <h3 className="sizelabel">L</h3>
                      </label>

                      <label>
                        <input
                          className="size"
                          type="radio"
                          name="size"
                          value="small"
                          onChange={(e) => {
                            console.log(e.target.value);
                          }}
                        />
                        <h3 className="sizelabel">XL</h3>
                      </label>

                      <label>
                        <input
                          className="size"
                          type="radio"
                          name="size"
                          value="small"
                          onChange={(e) => {
                            console.log(e.target.value);
                          }}
                        />
                        <h3 className="sizelabel">XXL</h3>
                      </label>
                    </div>

                    <div className="col-md-4">
                      <h3 className="craete-tit">Category</h3>

                      <Dropdown className="mt-4">
                        <Dropdown.Toggle
                          variant="success"
                          id="dropdown-basic"
                          className="d-flex justify-content-between align-items-center"
                        >
                          Clothes
                          <Icon
                            icon="ep:arrow-down-bold"
                            color="#000000"
                            width="16"
                            height="16"
                          />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item href="#/action-2" className="">
                            Clothes
                          </Dropdown.Item>
                          <Dropdown.Item href="#/action-2" className="">
                            Electronics
                          </Dropdown.Item>
                          <Dropdown.Item href="#/action-2" className="">
                            Art
                          </Dropdown.Item>
                          <Dropdown.Item href="#/action-2" className="">
                            Sports
                          </Dropdown.Item>
                          <Dropdown.Item href="#/action-2" className="">
                            0.05 SOL
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>

                    <div className="col-md-4">
                      <h3 className="craete-tit">Colors</h3>

                      <Dropdown className="mt-4">
                        <Dropdown.Toggle
                          variant="success"
                          id="dropdown-basic"
                          className="d-flex justify-content-between align-items-center"
                        >
                          Color
                          <Icon
                            icon="ep:arrow-down-bold"
                            color="#000000"
                            width="16"
                            height="16"
                          />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item href="#/action-2" className="">
                            Green
                            <img
                              src="\assets\images\physicalproduct\color6.png"
                              alt=""
                            />
                          </Dropdown.Item>
                          <Dropdown.Item href="#/action-2" className="">
                            Black
                            <img
                              src="\assets\images\physicalproduct\color5.png"
                              alt=""
                            />
                          </Dropdown.Item>
                          <Dropdown.Item href="#/action-2" className="">
                            Blue
                            <img
                              src="\assets\images\physicalproduct\color7.png"
                              alt=""
                            />
                          </Dropdown.Item>{" "}
                          <Dropdown.Item href="#/action-2" className="">
                            Orange
                            <img
                              src="\assets\images\physicalproduct\color8.png"
                              alt=""
                            />
                          </Dropdown.Item>{" "}
                          <Dropdown.Item href="#/action-2" className="">
                            Gray
                            <img
                              src="\assets\images\physicalproduct\color9.png"
                              alt=""
                            />
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>

                  <div className="row mt-5 product-pric">
                    <h3 className="craete-tit">Price</h3>
                    <div className="col-md-4 mt-2">
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="success"
                          id="dropdown-basic"
                          className="d-flex justify-content-between align-items-center "
                        >
                          <div>
                            <img src="\assets\images\icons\solona.png" alt="" />
                            Clothes
                          </div>
                          <Icon
                            icon="ep:arrow-down-bold"
                            color="#000000"
                            width="16"
                            height="16"
                          />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item href="#/action-2" className="">
                            <div>
                              <img
                                src="\assets\images\icons\solona.png"
                                alt=""
                              />
                              SOL
                            </div>
                          </Dropdown.Item>
                          <Dropdown.Item href="#/action-2" className="">
                            <div>
                              <img src="\assets\images\icons\dust.png" alt="" />
                              DUST
                            </div>
                          </Dropdown.Item>
                          <Dropdown.Item href="#/action-2" className="">
                            <div>
                              <img src="\assets\images\icons\usdc.png" alt="" />
                              USDC
                            </div>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="col-md-4 product-v mt-2">
                      <p className="val">0.05 SOL</p>
                    </div>
                    <div className="col-md-4 product-item mt-2">
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="female"
                          name="radio-buttons-group"
                          className="p-items"
                        >
                          <FormControlLabel
                            value="female"
                            label="Item #"
                            control={<Radio />}
                          />
                          <FormControlLabel
                            value="male"
                            label="SKU"
                            control={<Radio />}
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>

                    <div className="img-listing">
                      <h3 className="craete-tit mt-5">
                        Add Images For Listing
                      </h3>
                      <div className="col-sm-12">
                        <div className="row listing">
                          <div className="col-lg-3 col-md-4 col-6 w-center">
                            <img
                              src="../../assets/images/createyourown/chooseimg.png"
                              alt=""
                              className="img-fluid img-picker"
                            />
                          </div>
                          <div className="col-lg-3 col-md-4 col-6 w-center">
                            <img
                              src="../../assets/images/createyourown/chooseimg.png"
                              alt=""
                              className="img-fluid img-picker"
                            />
                          </div>
                          <div className="col-lg-3 col-md-4 col-6 w-center">
                            <img
                              src="../../assets/images/createyourown/chooseimg.png"
                              alt=""
                              className="img-fluid img-picker"
                            />
                          </div>
                          <div className="col-lg-3 col-md-4 col-6 w-center">
                            <img
                              src="../../assets/images/createyourown/chooseimg.png"
                              alt=""
                              className="img-fluid img-picker"
                            />
                          </div>
                          <div className="col-lg-3 col-md-4 col-6 w-center">
                            <img
                              src="../../assets/images/createyourown/chooseimg.png"
                              alt=""
                              className="img-fluid img-picker"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12  c-btn">
                        <button className="createitembtn me-3 mt-5">
                          Create
                        </button>
                      </div>
                      <hr className="divid" />
                    </div>

                    {/* <hr className="mt-4 divider" /> */}
                  </div>
                </div>
              </div>

              <div className="col-1"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Physicalitem;
